<div class="breadcrumbGlobal">
    <a (click)="navigateToHome()">
        <mat-icon>home</mat-icon>
    </a>
    <mat-icon>chevron_right</mat-icon>
    <a (click)="navigate()"><span translate>SUBSCRIPTIONS_ACCOUNTS.SUBSCRIPTIONS_ACCOUNTS_MANAGEMENT</span></a>
    <mat-icon>chevron_right</mat-icon>
    <span translate>PRODUCT_CONFIGURATION</span>
</div>
<tb-header parentPage="magocloudmanagedashboard"></tb-header>
<ms-industries-list [productID]="this.productID"></ms-industries-list>
